import noUiSlider from "nouislider";
import wNumb from "wnumb";

import './less/productListFilters.less';


const productListFilters = () => {
    let toggleFiltersBtns = document.getElementsByClassName('js-toggle-filters');
    let filtersBox = document.getElementById('js-filters-wrapper');
    
    
    if (toggleFiltersBtns && filtersBox) {
        [...toggleFiltersBtns]
            .map(btn => btn.addEventListener('click',
                () => filtersBox.classList.toggle('opened')));
        
        
        let mslider = document.getElementById('price-range');
        
        if(mslider !== undefined && mslider !== null) {
	        let min_start = document.getElementById('sliderMinStart').value;
	        let max_start = document.getElementById('sliderMaxStart').value;
	        let min_range = parseInt(document.getElementById('sliderMinRange').value);
	        let max_range = parseInt(document.getElementById('sliderMaxRange').value);
	        
	        noUiSlider.create(mslider, {
		        connect: true,
		        behaviour: 'tap',
		        tooltips: true,
		        start: [min_start, max_start],
		        range: {
			        'min': min_range,
			        'max': max_range
		        },
		        step: 1,
		        ariaFormat: wNumb({
			        decimals: 0
		        }),
		        format: wNumb({
			        decimals: 0,
			        thousand: '',
			        suffix: ' '+document.getElementsByTagName('html')[0].dataset.currency
		        })
	        });
	
	        let msliderInputs = [
		        document.getElementById('sliderMinStart'), // 0
		        document.getElementById('sliderMaxStart')  // 1
	        ];
	        let priceRangeInput = document.getElementById('sliderPriceRange'); // 0
	
	        mslider.noUiSlider.on('update', function (values, handle) {
		        let cleanValue = values[handle].split(' ')[0];
		        msliderInputs[handle].value = cleanValue;
		        priceRangeInput.value = `${document.getElementById('sliderMinStart').value};${document.getElementById('sliderMaxStart').value}`;
	        });
        }
    }

};

export default productListFilters;


// WEBPACK FOOTER //
// ./components/productListFilters/productListFilters.js